import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';

const RequireAuth = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;  // Optionally show a loading spinner
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;;
  }
  return <Outlet /> 

};

export default RequireAuth;
